/* eslint-disable */
export default {
  ringtones: 'Suonerie',
  incomingRingtone: 'Suoneria chiamata in entrata',
  outgoingRingtone: 'Suoneria chiamata in uscita',
  play: 'Riproduci',
  stop: 'Interrompi',
  upload: 'Carica',
  reset: 'Reimposta',
  save: 'Salva',
} as const;

// @key: @#@"ringtones"@#@ @source: @#@"Ringtones"@#@
// @key: @#@"incomingRingtone"@#@ @source: @#@"Incoming Ringtone"@#@
// @key: @#@"outgoingRingtone"@#@ @source: @#@"Outgoing Ringtone"@#@
// @key: @#@"play"@#@ @source: @#@"Play"@#@
// @key: @#@"stop"@#@ @source: @#@"Stop"@#@
// @key: @#@"upload"@#@ @source: @#@"Upload"@#@
// @key: @#@"reset"@#@ @source: @#@"Reset"@#@
// @key: @#@"save"@#@ @source: @#@"Save"@#@
